"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Radio_1 = __importDefault(require("../Radio/Radio"));
var __1 = require("..");
var react_1 = require("react");
exports.default = react_1.forwardRef(function RadioButton(_a, ref) {
    var label = _a.label, color = _a.color, labelPlacement = _a.labelPlacement, id = _a.id, disabled = _a.disabled, checked = _a.checked, value = _a.value, onChange = _a.onChange, radioClassName = _a.className;
    return (jsx_runtime_1.jsx(__1.FormControlLabel, { control: jsx_runtime_1.jsx(Radio_1.default, { checked: checked, onChange: function (event) {
                var _a = event.target, switchValue = _a.value, switchChecked = _a.checked;
                onChange === null || onChange === void 0 ? void 0 : onChange(switchValue, !!switchChecked, event);
            }, value: value, color: color, id: id, disabled: disabled, className: radioClassName }, void 0), ref: ref, label: label, labelPlacement: labelPlacement }, void 0));
});
//# sourceMappingURL=RadioButton.js.map